module.exports = __webpack_public_path__ + "img/bigwin-text_my.623f7766.png";